const URL_PARAMS = {
    RESET_CODE: 'resetCode',
    VALIDATION_KEY: 'validationKey',
    USERNAME: 'username',
    ID: 'id',
};

export default URL_PARAMS;
